<!-- eslint-disable -->
<template>
  <div>
    <table class="styled-table mt-n2">
      <thead>
        <tr class="text-center">
          <th v-for="(value, key) in headers" :key="key">
            {{ $t(value.name) }}
          </th>
          <th>{{ $t("action") }}</th>
        </tr>
      </thead>
      <v-fade-transition mode="out-in">
        <tbody v-if="!loader">
          <v-fade-transition
            v-for="(row, index) in data"
            :key="index"
            :class="{ variant: checkVariant(index) }"
            mode="out-in"
          >
            <tr class="text-center">
              <td v-for="(value, key) in headers" :key="key">
                <template>
                  <v-icon
                    v-show="getValue(row, value.keys) === 'active'"
                    color="green"
                    >mdi-check-circle</v-icon
                  >

                  <v-icon
                    v-show="getValue(row, value.keys) === 'inactive'"
                    color="red"
                    >mdi-close-circle</v-icon
                  >

                  <span v-if="!Array.isArray(getValue(row, value.keys))">
                    {{
                      value.keys == "city_id" ||value.keys == 'country_id'? null : getValue(row, value.keys)
                    }}</span
                  >
                </template>
                <template v-if="value.keys == 'city_id'">
                  {{ getCityName(getValue(row, value.keys)) }}
                </template>
                <template v-if="value.keys == 'country_id'">
                  {{ getCountryName(getValue(row, value.keys)) }}
                </template>
                
                <!-- <span
                    v-else
                    v-for="(item, index) in getValue(row, value.keys)"
                    :key="index"
                  >
                    ,{{ getValue(item, value.arrayKey) }}
                  </span> -->
              </td>
              <td>
                <v-icon @click="show(row)" v-if="showable" class="ma-1 icon"
                  >mdi-eye
                </v-icon>
                <v-icon
                  @click="edit(row)"
                  color="#007bff"
                  class="ma-1 icon"
                  v-if="editable"
                  >mdi-square-edit-outline
                </v-icon>
                <v-icon @click="copy(row)" v-if="copyable" class="ma-1 icon"
                  >mdi-content-copy
                </v-icon>

                <v-icon
                  size="30"
                  @click="deleteItem(row)"
                  v-if="deleteable"
                  color="red darken-2"
                  class="ma-1"
                  >mdi-delete-outline
                </v-icon>
                <v-icon
                  @click="select(row)"
                  v-if="selectable && type"
                  :value="row.selected"
                  color="success"
                  >mdi-check-bold</v-icon
                >
                <v-icon
                  @click="select(row)"
                  v-if="selectable && !type"
                  :value="row.selected"
                  color="error"
                  >mdi-close-thick</v-icon
                >
              </td>
            </tr>
          </v-fade-transition>
        </tbody>
      </v-fade-transition>
    </table>
    <div
      v-if="loader"
      class="mt-n6 d-flex justify-center align-center"
      style="width: 100%; height: 100px; background-color: whitesmoke"
    >
      <bounce-loader
        :loading="true"
        color="#afb42b"
        size="100px"
      ></bounce-loader>
    </div>
    <pagination @updatePage="$emit('updatePage', $event)" :data="meta" />
  </div>
</template>
<script>
import { City as Store } from "@/store/common/cities";
import { Country as CountryStore } from "@/store/common/country";

export default {
  data() {
    return {
      Store,
      CountryStore,
    };
  },
  props: {
    headers: {
      type: Object,
    },
    routerName: {
      type: String,
    },
    data: {
      type: Array,
    },
    editable: {
      type: Function,
    },
    deleteable: {
      type: Function,
    },
    copyable: {
      type: Function,
    },
    showable: {
      type: Function,
    },
    selectable: {
      type: Function,
    },
    loader: {
      type: Boolean,
      default: true,
    },
    type: {
      type: Boolean,
      default: true,
    },
    meta: {
      type: Object,
    },
  },
  methods: {
    getValue(obj, keys) {
      let value = obj;
      for (let index in keys) {
        value = value[keys[index]];
        if (keys[index] == "created_at") {
          value = value.substring(0, 10);
        }
      }

      return value;
    },
    edit(obj) {
      this.editable(obj);
    },
    deleteItem(obj) {
      this.deleteable(obj);
    },
    copy(obj) {
      this.copyable(obj);
    },
    show(obj) {
      this.$router.push(`${this.routerName}/${obj.id}`);
      this.showable(obj);
    },
    select(obj) {
      this.selectable(obj);
    },

    checkVariant(index) {
      return index % 2 == 1;
    },

    getCities(page) {
      Store.get({ page: page });
      //  countryStore.getCountries();
    },
    getCountries(page) {
      CountryStore.get({ page: page });
      //  countryStore.getCountries();
    },
    getCityName(id) {
      return this.cities.find((c) => c.id === id).en_name;
    },
    getCountryName(id) {
      return this.Countries.find((c) => c.id === id).en_name;
    },
  },
  computed: {
    cities() {
      return Store.cities;
    },
    Countries() {
      return CountryStore.countries;
    },
  },
  created() {
    if (this.$route.path == "/more/cards") {
      this.getCities({ page: 1 });
      console.log("kkkkkkkkkkkk", this.cities);
    }
    if (this.$route.path == "/more/cities") {
      this.getCountries({ page: 1 });
      console.log("kkkkkkkkkkkk", this.Countries);
    }
  },
};
</script>
<style scoped>
@import "@/assets/scss/_tables.scss";
</style>
